var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnTradeable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8678_28390)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6302 11.172H22.7955V8.27957C22.7955 6.06452 21.9314 3.98925 20.3847 2.41935C18.8273 0.849462 16.7579 0 14.5605 0C10.027 0 6.32555 3.70968 6.32555 8.27957V11.172H4.49082L0 36H29.121L24.6302 11.172ZM8.30962 8.27957C8.30962 4.80645 11.1151 1.97849 14.5605 1.97849C16.2352 1.97849 17.8033 2.63441 18.9767 3.83871C20.1607 5.02151 20.8114 6.60215 20.8114 8.27957V11.172H8.30962V8.27957Z",
    fill: "url(#paint0_linear_8678_28390)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2357 35.3333H0.885376L5.10952 12.0215H24.0115L28.2357 35.3333Z",
    fill: "url(#paint1_linear_8678_28390)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3368 10.8822H21.2701V8.36605C21.2701 6.5596 20.5767 4.86068 19.3073 3.58111C18.038 2.30154 16.3526 1.60261 14.5605 1.60261C10.859 1.60261 7.85094 4.63487 7.85094 8.36605V10.8822H6.78424V8.36605C6.78424 4.04347 10.2724 0.527344 14.5605 0.527344C16.6406 0.527344 18.5927 1.34455 20.054 2.81767C21.5261 4.30154 22.3261 6.26928 22.3261 8.3553V10.8714L22.3368 10.8822Z",
    fill: "url(#paint2_linear_8678_28390)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4136 14.1187C7.83776 14.1187 8.18162 13.7721 8.18162 13.3445C8.18162 12.9169 7.83776 12.5703 7.4136 12.5703C6.98943 12.5703 6.64557 12.9169 6.64557 13.3445C6.64557 13.7721 6.98943 14.1187 7.4136 14.1187Z",
    fill: "url(#paint3_linear_8678_28390)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41362 13.9582C7.74942 13.9582 8.02165 13.6838 8.02165 13.3453C8.02165 13.0068 7.74942 12.7324 7.41362 12.7324C7.07782 12.7324 6.8056 13.0068 6.8056 13.3453C6.8056 13.6838 7.07782 13.9582 7.41362 13.9582Z",
    fill: "url(#paint4_linear_8678_28390)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07688 12.9344L7.03015 12.9785L7.759 13.7636L7.80573 13.7196L7.07688 12.9344Z",
    fill: "url(#paint5_linear_8678_28390)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82217 13.0061L7.77844 12.959L6.99958 13.6937L7.04331 13.7408L7.82217 13.0061Z",
    fill: "url(#paint6_linear_8678_28390)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5154 14.1187C21.9396 14.1187 22.2834 13.7721 22.2834 13.3445C22.2834 12.9169 21.9396 12.5703 21.5154 12.5703C21.0912 12.5703 20.7474 12.9169 20.7474 13.3445C20.7474 13.7721 21.0912 14.1187 21.5154 14.1187Z",
    fill: "url(#paint7_linear_8678_28390)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5154 13.9582C21.8512 13.9582 22.1235 13.6838 22.1235 13.3453C22.1235 13.0068 21.8512 12.7324 21.5154 12.7324C21.1796 12.7324 20.9074 13.0068 20.9074 13.3453C20.9074 13.6838 21.1796 13.9582 21.5154 13.9582Z",
    fill: "url(#paint8_linear_8678_28390)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1709 12.9305L21.1242 12.9746L21.8531 13.7597L21.8998 13.7156L21.1709 12.9305Z",
    fill: "url(#paint9_linear_8678_28390)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.927 12.9983L21.8833 12.9512L21.1044 13.6859L21.1482 13.733L21.927 12.9983Z",
    fill: "url(#paint10_linear_8678_28390)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6569 34.8492C27.0811 34.8492 27.425 34.5025 27.425 34.075C27.425 33.6474 27.0811 33.3008 26.6569 33.3008C26.2328 33.3008 25.8889 33.6474 25.8889 34.075C25.8889 34.5025 26.2328 34.8492 26.6569 34.8492Z",
    fill: "url(#paint11_linear_8678_28390)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.657 34.6887C26.9928 34.6887 27.265 34.4143 27.265 34.0758C27.265 33.7373 26.9928 33.4629 26.657 33.4629C26.3212 33.4629 26.049 33.7373 26.049 34.0758C26.049 34.4143 26.3212 34.6887 26.657 34.6887Z",
    fill: "url(#paint12_linear_8678_28390)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3156 33.6649L26.2689 33.709L26.9977 34.4941L27.0444 34.45L26.3156 33.6649Z",
    fill: "url(#paint13_linear_8678_28390)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0642 33.7307L27.0204 33.6836L26.2416 34.4183L26.2853 34.4654L27.0642 33.7307Z",
    fill: "url(#paint14_linear_8678_28390)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80544 34.8492C3.22961 34.8492 3.57347 34.5025 3.57347 34.075C3.57347 33.6474 3.22961 33.3008 2.80544 33.3008C2.38127 33.3008 2.03741 33.6474 2.03741 34.075C2.03741 34.5025 2.38127 34.8492 2.80544 34.8492Z",
    fill: "url(#paint15_linear_8678_28390)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80547 34.6887C3.14127 34.6887 3.41349 34.4143 3.41349 34.0758C3.41349 33.7373 3.14127 33.4629 2.80547 33.4629C2.46967 33.4629 2.19745 33.7373 2.19745 34.0758C2.19745 34.4143 2.46967 34.6887 2.80547 34.6887Z",
    fill: "url(#paint16_linear_8678_28390)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46787 33.6629L2.42114 33.707L3.14999 34.4921L3.19672 34.4481L2.46787 33.6629Z",
    fill: "url(#paint17_linear_8678_28390)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21481 33.7346L3.17108 33.6875L2.39222 34.4222L2.43595 34.4693L3.21481 33.7346Z",
    fill: "url(#paint18_linear_8678_28390)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6302 11.172H22.7955V8.27957C22.7955 6.06452 21.9314 3.98925 20.3847 2.41935C18.8273 0.849462 16.7579 0 14.5605 0C10.027 0 6.32555 3.70968 6.32555 8.27957V11.172H4.49082L0 36H29.121L24.6302 11.172ZM8.30962 8.27957C8.30962 4.80645 11.1151 1.97849 14.5605 1.97849C16.2352 1.97849 17.8033 2.63441 18.9767 3.83871C20.1607 5.02151 20.8114 6.60215 20.8114 8.27957V11.172H8.30962V8.27957Z",
    fill: "#FF2F37"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8678_28390",
    x1: 14.6992,
    y1: -3.6129,
    x2: 14.5583,
    y2: 36.2903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8678_28390",
    x1: 14.5392,
    y1: 38.3978,
    x2: 14.756,
    y2: 2.07527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8678_28390",
    x1: 14.6138,
    y1: -3.0533,
    x2: 14.538,
    y2: 13.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8678_28390",
    x1: 7.42426,
    y1: 12.0757,
    x2: 7.40258,
    y2: 14.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8678_28390",
    x1: 7.42429,
    y1: 12.4098,
    x2: 7.40261,
    y2: 14.3776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8678_28390",
    x1: 6.82807,
    y1: 12.6979,
    x2: 8.01115,
    y2: 13.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8678_28390",
    x1: 8.05683,
    y1: 12.7553,
    x2: 6.77844,
    y2: 13.9275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8678_28390",
    x1: 21.5261,
    y1: 12.0757,
    x2: 21.5044,
    y2: 14.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8678_28390",
    x1: 21.5261,
    y1: 12.4098,
    x2: 21.5044,
    y2: 14.3776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8678_28390",
    x1: 20.9143,
    y1: 12.7013,
    x2: 22.0974,
    y2: 13.9711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8678_28390",
    x1: 22.1544,
    y1: 12.7396,
    x2: 20.876,
    y2: 13.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8678_28390",
    x1: 26.6676,
    y1: 32.8062,
    x2: 26.6459,
    y2: 35.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8678_28390",
    x1: 26.6676,
    y1: 33.1403,
    x2: 26.646,
    y2: 35.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8678_28390",
    x1: 26.0668,
    y1: 33.4284,
    x2: 27.2425,
    y2: 34.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8678_28390",
    x1: 27.2988,
    y1: 33.4799,
    x2: 26.0132,
    y2: 34.6442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8678_28390",
    x1: 2.81611,
    y1: 32.8062,
    x2: 2.79443,
    y2: 35.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8678_28390",
    x1: 2.81614,
    y1: 33.1403,
    x2: 2.79446,
    y2: 35.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8678_28390",
    x1: 2.21128,
    y1: 33.4338,
    x2: 3.387,
    y2: 34.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8678_28390",
    x1: 3.44947,
    y1: 33.4838,
    x2: 2.17171,
    y2: 34.6408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8678_28390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.121,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnTradeable);
export default __webpack_public_path__ + "static/media/unTradeable.69b5935f07449a0a3c94e50dbe7e9504.svg";
export { ForwardRef as ReactComponent };